import styled from "styled-components";
import fontSize from "../../theme/fonts/FontTheme";

const Heading = styled.h1`
  font-weight: 400;
  font-size: ${fontSize.xl};
  letter-spacing: 0.12em;
  display: inline-block;
  text-transform: uppercase;
  color: ${({ color }) => color || "000000"};
`;

function H1({ children, color }) {
  return <Heading color={color}>{children}</Heading>;
}

export default H1;
